import React, { useEffect, useState } from "react";
import styles from "./DashboardLoader.module.scss";
import ProgressWithMessages from "./ProgressWithMessage";
import SpinnerMemoized from "./SpinnerMemoized";
import { useSelector } from "react-redux";
type props = {
  status: string;
};
const DashboardLoader = () => {
  return (
    <div className={styles.loaderWrapper}>
      <SpinnerMemoized />
      <div className={styles.separator}></div>
      <ProgressWithMessages />
    </div>
  );
};

export default DashboardLoader;
